import { Alert, Checkbox, DatePicker, Tabs } from "antd";
import { useState, useEffect } from "react";
import fakeDispatch from "../../../utils/fakeDispatch";
import useAdminDataStore, { selectCurrentGroupId, selectAllGroups } from "../../../store/adminData/adminData";
import { ChantInput } from "../../../CommonComponents";
import { Editor } from "react-draft-wysiwyg";
import { ContentState, EditorState } from "draft-js";
import ImageUploadButton from "../website/ImageUploaderButton";
import {
  fbGetGroupDetails,
  saveWelcomeCardDetails,
  sendBareNotification,
} from "../../../services/firebaseService/endPoints/admin/content";
import htmlToDraft from "html-to-draftjs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setGettingStartedItemStatus } from "../../../redux/actions/adminData";
import {
  GUIDE_ONBOARD,
  TOPIC_CREATE_WELCOME_CARD,
} from "../../../constants/gettingStarted";
import logger from "../../../utils/logger";
import dayjs from "dayjs";
import { postUpdateCDNUtil } from "../../../helperFunctions/util";
import { buildWelcomeCardImageUrl } from "../../../utils/firebaseStorageUtils";
import {
  ChantButton,
  DescriptionText,
  ScreenHeader,
} from "../../../CommonComponents";

const { TabPane } = Tabs;

const KEY_ORDER = {
  both: 0,
  members: 0,
  nonMembers: 1,
};
const CARD_TEMPLATE = {
  title: "",
  image: null,
  button: {
    title: "",
    url: "",
  },
  showEmail: false,
  republishCard: false,
  showCardUntilTimestamp: null,
  welcomeCardRepublishTimestamp: dayjs().unix(),
  filledKeys: [],
  sendNotification: false,
};

const PageTabs = {
  members: "Members",
  nonMembers: "Non Members",
};

const Welcome = () => {
  const currentGroup = useAdminDataStore(selectCurrentGroupId);
  const allGroups = useAdminDataStore(selectAllGroups);
  const adminData = allGroups[currentGroup];

  const [welcomeCards, setWelcomeCards] = useState({
    key: ["members"],
    values: [
      {
        ...JSON.parse(JSON.stringify(CARD_TEMPLATE)),
        details: EditorState.createEmpty(),
      },
    ],
  });
  const [errorInForm, setErrorInForm] = useState({
    isError: false,
    visible: false,
    message: "",
  });
  const [saving, setSaving] = useState(false);
  const [currenTab, setCurrenTab] = useState(PageTabs.members);

  const handleInputChange = (value, key, index) => {
    setWelcomeCards((prev) => {
      let wc = prev;
      if (key.includes(".")) {
        let dataKeys = key.split(".");
        let finalPathValue = wc.values[index];
        for (let i = 0; i < dataKeys.length - 1; i++) {
          finalPathValue = finalPathValue[dataKeys[i]];
        }
        finalPathValue[dataKeys.pop()] = value;
      } else {
        wc.values[index][key] = value;
      }
      if (value) {
        wc.values[index].filledKeys = Array.from(
          new Set([...wc.values[index].filledKeys, key])
        );
      } else {
        if (wc.values[index].filledKeys.includes(key)) {
          wc.values[index].filledKeys.splice(
            wc.values[index].filledKeys.indexOf(key),
            1
          );
        }
      }
      return { ...wc };
    });
  };

  const handleEditorStateChange = (state, key, index) => {
    setWelcomeCards((prev) => {
      let wc = prev;
      wc.values[index][key] = state;
      let details = state;
      if (details.getCurrentContent().getPlainText("").length > 0) {
        wc.values[index].filledKeys = Array.from(
          new Set([...wc.values[index].filledKeys, key])
        );
      } else {
        if (wc.values[index].filledKeys.includes(key)) {
          wc.values[index].filledKeys.splice(
            wc.values[index].filledKeys.indexOf(key),
            1
          );
        }
      }
      return { ...wc };
    });
  };

  const handleDateChange = (name, value, index) => {
    setWelcomeCards((prev) => {
      let wc = prev;

      // Handle null, undefined, and invalid dates
      if (value === null || value === undefined) {
        wc.values[index][name] = null;
      } else if (!Array.isArray(value) && dayjs(value).isValid()) {
        let hours = 0,
          minutes = 0,
          seconds = 59;

        wc.values[index][name] = dayjs(value)
          .set({
            h: hours,
            m: minutes,
            second: seconds,
          })
          .unix();
      } else {
        // Invalid date, set to null
        wc.values[index][name] = null;
      }

      return { ...wc };
    });
  };

  const handleSubmit = () => {
    setSaving(true);
    let wc = welcomeCards;
    for (let index = 0; index < wc.key.length; index++) {
      let value = wc.values[index];

      if (
        value.filledKeys.length > 0 &&
        (!value.title || !value.details.getCurrentContent().getPlainText(""))
      ) {
        setErrorInForm({
          isError: true,
          visible: true,
          message: "Please fill the required fields.",
        });
        setSaving(false);
        window.scrollTo(0, 0);
        return;
      }
    }

    let updateData = {};
    let index = 0;
    for (let key of wc.key) {
      let value = wc.values[index];
      if (value.filledKeys.length > 0) {
        updateData[key] = value;
      }
      index++;
    }

    saveWelcomeCardDetails(updateData, currentGroup).then(() => {
      postUpdateCDNUtil(currentGroup);
      for (let key of Object.keys(updateData)) {
        let value = updateData[key];
        let details = ContentState.createFromBlockArray(
          htmlToDraft(value.details || "<p></p>")
        );
        if (value.sendNotification) {
          sendBareNotification(
            `${adminData.data.groupName} ${value.title}`,
            details.getPlainText(""),
            currentGroup,
            null,
            key === "nonMembers" || key === "both",
            true,
            key === "members" || key === "both"
          );
        }
      }
      getWelcomeCardDetails();

      toast.success("Updated welcome card details");
    });
  };

  const createInitialState = () => {
    let regCodeRole = adminData.data.regCodeRole;
    if (regCodeRole === "fan") {
      setWelcomeCards((prev) => {
        let wc = prev;
        wc.key = ["members", "nonMembers"];
        wc.values.push({
          ...JSON.parse(JSON.stringify(CARD_TEMPLATE)),
          details: EditorState.createEmpty(),
        });
        return { ...wc };
      });
    }
  };

  const getWelcomeCardDetails = async () => {
    let welcomeCardDetails = await fbGetGroupDetails(
      currentGroup
    ).then((data) => data.welcomeCardDetails);
    if (welcomeCardDetails) {
      fakeDispatch(
        setGettingStartedItemStatus(
          currentGroup,
          GUIDE_ONBOARD,
          TOPIC_CREATE_WELCOME_CARD,
          true
        )
      );

      let wc = {
        key: [],
        values: [],
      };
      let keys = Object.keys(welcomeCardDetails);
      if (keys.includes("both")) {
        wc.key = ["both"];
      } else {
        let regCodeRole = adminData.data.regCodeRole;
        if (regCodeRole === "fan") {
          wc.key = ["members", "nonMembers"];
        } else {
          wc.key = ["members"];
        }
      }

      wc.values = Array.from(
        { length: wc.key.length },
        () => {
          return {
            ...JSON.parse(JSON.stringify(CARD_TEMPLATE)),
            details: EditorState.createEmpty(),
          };
        }
      );
      for (var key of Object.keys(welcomeCardDetails)) {
        let value = welcomeCardDetails[key];
        value.filledKeys = ["title", "details"];
        if (value.details) {
          try {
            let blockArray = htmlToDraft(value.details || "<p></p>");
            if (blockArray) {
              let contentState = ContentState.createFromBlockArray(blockArray);
              let editorState = EditorState.createWithContent(contentState);
              value.details = editorState;
            } else {
              value.details = EditorState.createEmpty();
            }
          } catch (e) {
            logger.error(e);
          }
        } else {
          value.details = EditorState.createEmpty();
        }
        if (value.image) {
          value.image = buildWelcomeCardImageUrl(
            currentGroup,
            KEY_ORDER[key]
          );
        } else {
          value.image = null;
        }
        if (value.button) {
          if (value.button.title) {
            value.filledKeys.push("button.title");
          }
          if (value.button.url) {
            value.filledKeys.push("button.url");
          }
        }

        // Ensure showCardUntilTimestamp is properly handled when loading from Firebase
        if (value.showCardUntilTimestamp === undefined) {
          value.showCardUntilTimestamp = null;
        }

        wc.values[KEY_ORDER[key]] = value;
      }
      setWelcomeCards({ ...wc });
      setSaving(false);
    }
  };

  useEffect(() => {
    createInitialState();
    getWelcomeCardDetails();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (currentGroup) {
      createInitialState();
      getWelcomeCardDetails();
    }
  }, [currentGroup]); // eslint-disable-line react-hooks/exhaustive-deps

  const drawCardLayout = (title, index) => {
    let showCardUntilTimestamp = null;
    if (welcomeCards.values[index].showCardUntilTimestamp) {
      showCardUntilTimestamp = dayjs.unix(
        welcomeCards.values[index].showCardUntilTimestamp
      );
    }
    return (
      <>
        <p style={{ fontSize: 20, fontWeight: "bold", marginBottom: "16px" }}>{title}</p>
        <div className="chant-form-body">
          <ChantInput
            value={welcomeCards.values[index].title}
            label="Card Title"
            onChange={(e) => handleInputChange(e.target.value, "title", index)}
            name="title"
            placeholder="Examples: Welcome, Renew Membership, Update, Important, etc"
            tabIndex="2"
            maxLength={25}
            required
          />
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Details<span style={{ color: "#ff0000" }}>*</span>
            </label>
            <div style={{ border: "1px solid #ced4da", borderRadius: 5 }}>
              <Editor
                editorState={
                  typeof welcomeCards.values[index].details === "object"
                    ? welcomeCards.values[index].details
                    : undefined
                }
                onEditorStateChange={(state) =>
                  handleEditorStateChange(state, "details", index)
                }
                toolbar={{
                  options: ["inline", "list", "link"],
                  inline: { inDropdown: false, options: ["bold", "italic", "underline"] },
                  list: { inDropdown: false, options: ["unordered", "ordered"] },
                }}
                stripPastedStyles={true}
                tabIndex="2"
              />
            </div>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>Image</label>
            <ImageUploadButton
              text="Upload"
              images={[welcomeCards.values[index].image]}
              onSave={(images) => {
                let image = images[0];
                setWelcomeCards((prev) => {
                  let wc = prev;
                  wc.values[index].image = image;
                  return { ...wc };
                });
              }}
            />
          </div>
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>Show Button / Web URL?</label>
            <div style={{ display: "flex", gap: "12px" }}>
              <input
                style={{ flex: 1, padding: "4px 8px", border: "1px solid #d9d9d9", borderRadius: "6px", fontSize: "14px" }}
                value={welcomeCards.values[index].button.title}
                onChange={(e) => handleInputChange(e.target.value, "button.title", index)}
                name="button.title"
                placeholder="Enter button name"
                tabIndex="2"
                maxLength={25}
              />
              <input
                style={{ flex: 2, padding: "4px 8px", border: "1px solid #d9d9d9", borderRadius: "6px", fontSize: "14px" }}
                value={welcomeCards.values[index].button.url}
                onChange={(e) => handleInputChange(e.target.value, "button.url", index)}
                name="button.url"
                placeholder="Enter destination url"
                tabIndex="2"
              />
            </div>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "8px" }}>
              Show member email they used to register?
            </label>
            <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
              <Checkbox
                checked={welcomeCards.values[index].showEmail}
                onChange={(e) => {
                  setWelcomeCards((prev) => {
                    let wc = prev;
                    wc.values[index].showEmail = e.target.checked;
                    return { ...wc };
                  });
                }}
                value="secondary"
                color="primary"
                aria-label="Show email checkbox"
                tabIndex="5"
              />
              <p style={{ fontSize: 13, margin: 0 }}>
                Can be a helpful reminder during renewal season.
              </p>
            </div>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>Show card until</label>
            <DatePicker
              tabIndex="2"
              value={showCardUntilTimestamp}
              onChange={(value) => handleDateChange("showCardUntilTimestamp", value, index)}
              disabledDate={(current) => current && current < dayjs().startOf("day")}
            />
            <p style={{ fontSize: 13, marginTop: "4px", marginBottom: 0 }}>
              If no date selected, will remain live for a member until they click &apos;x&apos; to close card.
            </p>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "8px" }}>Republish Card</label>
            <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
              <Checkbox
                checked={welcomeCards.values[index].republishCard}
                onChange={(e) => {
                  setWelcomeCards((prev) => {
                    let wc = prev;
                    wc.values[index].republishCard = e.target.checked;
                    if (e.target.checked) {
                      wc.values[index].welcomeCardRepublishTimestamp = dayjs().unix();
                    }
                    return { ...wc };
                  });
                }}
                value="secondary"
                color="primary"
                aria-label="Republish checkbox"
                tabIndex="5"
              />
              <p style={{ fontSize: 13, margin: 0 }}>
                The card can be closed in the app by clicking &apos;x&apos;. You can republish
                the card for all by checking this box and saving. Note: this checkbox will
                appear unchecked each time you open this page, allowing you to republish as needed.
              </p>
            </div>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "8px" }}>Send notification</label>
            <Checkbox
              checked={welcomeCards.values[index].sendNotification}
              onChange={(e) => {
                setWelcomeCards((prev) => {
                  let wc = prev;
                  wc.values[index].sendNotification = e.target.checked;
                  return { ...wc };
                });
              }}
              value="secondary"
              color="primary"
              aria-label="Send notification checkbox"
              tabIndex="5"
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="col">
      {errorInForm.isError && errorInForm.visible && (
        <div className="mx-5 mt-2">
          <Alert
            message="Error"
            description={errorInForm.message}
            type="error"
            closable
            // className="mb-3"
            afterClose={() => {
              setErrorInForm((prev) => ({ ...prev, visible: false }));
            }}
          />
        </div>
      )}
      <div className="md-5 border-box" style={{ padding: "12px" }}>
        <ScreenHeader title="Welcome" />
        <DescriptionText showBackground>
          Show a custom 'welcome' card in the home feed. Set to show for
          members, fans or both. Provide an optional web link. Card can be
          closed by members (click on 'x'). Republish the card as needed. Also
          note that any chat post can be pinned to the home feed as an
          'announcement'.
        </DescriptionText>
        <div
          className="p-3"
          style={{
            backgroundColor: "white",
            marginTop: "2px",
          }}
        >
          <Tabs
            onChange={(key) => {
              setCurrenTab(PageTabs[key]);
            }}
            type="card"
          >
            {Object.keys(PageTabs)
              .filter((key) =>
                adminData.data.regCodeRole !== "fan" &&
                key === "nonMembers"
                  ? false
                  : true
              )
              .map((key) => {
                return <TabPane tab={PageTabs[key]} key={key}></TabPane>;
              })}
          </Tabs>
          {currenTab === PageTabs.members &&
            drawCardLayout("Members", 0)}
          {currenTab === PageTabs.nonMembers &&
            adminData.data.regCodeRole === "fan" && (
              <>
                <div className="page-break mt-2"></div>
                <div
                  className=" mt-5"
                  style={{ display: "flex", flexWrap: "nowrap", gap: 20 }}
                >
                  <div>
                    <label>
                      Show above details to members and non-members?
                    </label>
                  </div>
                  <Checkbox
                    style={{ marginTop: "1px" }}
                    checked={welcomeCards.key[0] === "both"}
                    onChange={(e) => {
                      setWelcomeCards((prev) => {
                        let wc = prev;
                        if (e.target.checked) {
                          wc.key = ["both"];
                          return { ...wc };
                        } else {
                          wc.key = ["members", "nonMembers"];
                          if (!wc.values[1]) {
                            wc.values.push({
                              ...JSON.parse(JSON.stringify(CARD_TEMPLATE)),
                              details: EditorState.createEmpty(),
                            });
                          }
                          return { ...wc };
                        }
                      });
                    }}
                    value="secondary"
                    color="primary"
                    aria-label="Show welcome cards checkbox"
                    tabIndex="5"
                  />
                </div>
                {welcomeCards.key.includes("nonMembers") &&
                  drawCardLayout("Non-Members (Fans)", 1)}
              </>
            )}
          <div
            style={{ display: "flex", flexWrap: "wrap" }}
            className=" justify-content-center"
          >
            <ChantButton
              loading={saving}
              onClick={handleSubmit}
            >
              Submit
            </ChantButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
